import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import NavbarDropdownComponents from './NavbarDropdownComponents';
import NavbarDropdown from './NavbarDropdown';
import NavbarDropdownTwo from './NavbarDropdownTwo';
import {
  buildMenu
} from '../../routes';
import { NavItem } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import * as icon from 'react-bootstrap-icons';
import { breakpoints } from '../../helpers/utils';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import AppContext from '../../context/Context';

const NavbarTopDropDownMenus = ({ setNavbarCollapsed, setShowBurgerMenu, otherInfo }) => {
  const { isCombo, isTopNav } = useContext(AppContext);
  const { inventoryEnabled, nutritionAnalysis } = otherInfo;

  //const components = [componentRoutes, pluginRoutes, utilityRoutes];

  //const pages = [pageRoutes, calenderRoutes, kanbanRoutes, widgetsRoutes, chatRoutes, emailRoutes, ECommerceRoutes];

  const handleSetNavbarCollapsed = () => {
    const windowWidth = window.innerWidth;
    isTopNav && !isCombo && windowWidth < breakpoints[topNavbarBreakpoint] && setNavbarCollapsed(false);
    isCombo && windowWidth < breakpoints[navbarBreakPoint] && setShowBurgerMenu(false);
  };
  /*  const manageRoutingItems=(manageGroup={})=>{
     const childrenItems=(manageGroup.children||[]);
     return childrenItems;
   } */
  return (
    <>
      {
        (buildMenu(otherInfo) || []).map((item, i) => {
          if ((item.children || []).length === 0) {
            return <NavItem key={i} onClick={handleSetNavbarCollapsed}>
              <NavLink className="nav-link align-item-center" to={item.to}>
                <icon.HouseDoorFill className='mb-2' /> {item.name}
              </NavLink>
            </NavItem>
          } else {
            return item.name === 'Manage' ? <NavbarDropdown
              title={item.name}
              items={item.children}
              handleSetNavbarCollapsed={handleSetNavbarCollapsed}
            /> :
              item.name === 'Reports' ? <NavbarDropdownTwo
                title={item.name}
                items={item.children}
                handleSetNavbarCollapsed={handleSetNavbarCollapsed}
              /> :
                <NavbarDropdownComponents key={i}
                  title={item.name}
                  items={item.children}
                  handleSetNavbarCollapsed={handleSetNavbarCollapsed} />
          }
        })
      }
      {/* <NavbarDropdown
        title={homeRoutes.name}
        items={homeRoutes.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      <NavbarDropdown title={pageRoutes.name} items={pages} handleSetNavbarCollapsed={handleSetNavbarCollapsed} />
      <NavbarDropdownComponents
        title={componentRoutes.name}
        items={components}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      />
      <NavbarDropdown
        title={authenticationRoutes.name}
        items={authenticationRoutes.children}
        handleSetNavbarCollapsed={handleSetNavbarCollapsed}
      /> */}
    </>
  );
};

NavbarTopDropDownMenus.propTypes = { setNavbarCollapsed: PropTypes.func.isRequired };

export default NavbarTopDropDownMenus;
